import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"bell\"><path d=\"M8 16c.9 0 1.6-.7 1.6-1.6H6.4c0 .9.7 1.6 1.6 1.6zm4.9-4.9V7c0-2.5-1.3-4.6-3.7-5.2v-.6C9.2.5 8.7 0 8 0S6.8.5 6.8 1.2v.6C4.4 2.3 3.1 4.4 3.1 7v4.1l-1.6 1.6v.8h13.1v-.8l-1.7-1.6z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/bell.svg
// module id = f80l
// module chunks = 39 44